exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Right-module__right-wrapper___12WRh{display:flex;flex-wrap:wrap;gap:1rem;justify-content:flex-end}", ""]);

// exports
exports.locals = {
	"right-wrapper": "Right-module__right-wrapper___12WRh"
};